import { useEffect } from 'react';

import { defaultWhiteLabel, WhiteLabel } from 'pages/partners/pages/site_branding/interfaces';
import { WhiteLabelForm } from 'pages/partners/pages/site_branding/components/WhiteLabelForm';
import { IntlProvider, LocalizationProvider } from '@progress/kendo-react-intl';
import { GMetrixDropdown } from 'components/GMetrixDropdown/GMetrixDropdown';
import { GMetrixButton } from 'components/GMetrixButton/GMetrixButton';
import { helpContent } from 'pages/partners/pages/site_branding/help';
import { API } from 'pages/partners/pages/site_branding/API';
import { HelpSidebarTrigger } from 'components/help_sidebar';
import { FormattedMessage, useIntl } from 'react-intl';
import { DefaultLayout } from 'components/layout';
import { Card, Col, Row } from 'react-bootstrap';
import { KendoIntlProvider } from 'app/culture';
import { useSuperState } from 'hooks';
import { useApp } from 'app';

import 'pages/partners/pages/site_branding/styles/SiteBranding.scss';

export const SiteBranding = () => {

    const { userId } = useApp();

    const { formatMessage, locale } = useIntl();
    const [state, setState] = useSuperState({
        messageStatus: '',
        partnerId: -1,
        selectedWhiteLabelObj: defaultWhiteLabel as WhiteLabel,
        whiteLabelData: [] as WhiteLabel[]
    });
    const { messageStatus, partnerId, selectedWhiteLabelObj, whiteLabelData } = state;

    const retrieveCurrentWhiteLabel = async (initialLoad: boolean) => {

        // Snag partnerId from URL.
        const paramPartnerId = new URLSearchParams(window.location.search).get('PId');
        setState({ partnerId: Number(paramPartnerId) });
        if (paramPartnerId) {

            const responseData = await API.getpartnerWhiteLabels(parseInt(paramPartnerId), userId);
            setState({ whiteLabelData: responseData });
            if (responseData.length > 0) {

                if (!initialLoad) {

                    const currentIndex = responseData.length - 1;
                    setState({ selectedWhiteLabelObj: responseData[currentIndex] });

                } else {

                    setState({ selectedWhiteLabelObj: responseData[0] });

                }

            }

        }

    };

    const onStatusChange = (event: any, typeOfIcon: string) => {

        const eventResponse = event.response.response;
        if (event.response.status === 200) {

            switch (typeOfIcon) {

                case 'primaryIcon':
                    setState({ selectedWhiteLabelObj: { ...selectedWhiteLabelObj, PrimaryIcon: eventResponse } });
                    break;
                case 'secondaryIcon':
                    setState({ selectedWhiteLabelObj: { ...selectedWhiteLabelObj, SecondaryIcon: eventResponse } });
                    break;
                case 'backgroundImage':
                    setState({ selectedWhiteLabelObj: { ...selectedWhiteLabelObj, BackgroundImage: eventResponse } });
                    break;
                case 'loginBackgroundImage':
                    setState({ selectedWhiteLabelObj: { ...selectedWhiteLabelObj, LoginBackgroundImage: eventResponse } });
                    break;
                default:
                    return;

            }

        }

    };

    const handleSelect = (object: any) => {

        // New White label if e.target.value is -1.
        if (!object) {

            setState({ selectedWhiteLabelObj: defaultWhiteLabel });

        } else {

            setState({ selectedWhiteLabelObj: object });

        }
        setState({ messageStatus: '' });

    };

    const handleSaveButton = async (e: any) => {

        e.preventDefault();
        const response = await API.createEditPartnerWhiteLabel(partnerId, userId, selectedWhiteLabelObj);
        if (response.Successful) {

            setState({ messageStatus: response.MsgSuccess, whiteLabelData });

        }
        if (selectedWhiteLabelObj.Id === null) {

            retrieveCurrentWhiteLabel(false);

        }

    };

    useEffect(() => {

        retrieveCurrentWhiteLabel(true);

    }, []);

    return (
        <DefaultLayout>
            <KendoIntlProvider>
                <LocalizationProvider language={locale}>
                    <IntlProvider locale={locale}>
                        <div className="d-flex justify-content-between align-items-baseline">
                            <div className="d-flex flex-column">
                                <h2>
                                    <FormattedMessage defaultMessage="Site Branding Form" id="site_branding_form.bd83f094" />
                                </h2>
                                <GMetrixDropdown
                                    dataItemKey="Id"
                                    dataItems={whiteLabelData}
                                    label={formatMessage({ id: 'select_white_label_to_edit.ac24e1b8', defaultMessage: 'Select White Label to Edit' })}
                                    onChange={handleSelect}
                                    textField="Name"
                                    value={selectedWhiteLabelObj}
                                />

                            </div>
                            <div className={'d-flex align-items-center gap-1'}>
                                <HelpSidebarTrigger content={helpContent} />
                                <GMetrixButton
                                    onClick={e => handleSaveButton(e)}
                                    title={formatMessage({ id: 'save_current_white_label.e46d308c', defaultMessage: 'Save Current White Label' })}
                                    variant="success"
                                >
                                    <FormattedMessage defaultMessage="Save" id="save.d44082ae" />
                                </GMetrixButton>
                            </div>
                        </div>
                        <hr/>
                        <Card>
                            <Card.Body>
                                {messageStatus.length > 0 && (
                                <Row>
                                    <Col>
                                        <h3 className="m-3" style={{ textAlign: 'center' }}>
                                            {messageStatus}
                                        </h3>
                                    </Col>
                                </Row>
                                )}
                                {selectedWhiteLabelObj && (
                                <WhiteLabelForm
                                    onStatusChange={onStatusChange}
                                    partnerId={partnerId}
                                    selectedWhiteLabelObj={selectedWhiteLabelObj}
                                    setSelectedWhiteLabelObj={val => setState({ selectedWhiteLabelObj: val })}
                                />
                                )}
                            </Card.Body>
                        </Card>

                    </IntlProvider>
                </LocalizationProvider>
            </KendoIntlProvider>
        </DefaultLayout>
    );

};
